import { SvgIcon, SvgIconProps } from "@mui/material";
import { AlphaGlyphMinimized, AlphaPlusMinimized } from "src/components/icons-mui/alpha-icon-glyph";

export const IconAlphaStrongMinimized = (props: SvgIconProps) => (
    <SvgIcon {...props} viewBox="0 0 14 14">
        <AlphaGlyphMinimized />
        <AlphaPlusMinimized />
    </SvgIcon>
);
